import { html } from 'lit';
import type { Purpose } from '@common/types/model.d.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

//
// renders a single user bound purpose
//
export const singlePurposeUserBoundEdit = function render(this: TefComs4p, purpose : Purpose) {
  return html`
    <div class="container container--size-full container--prio-bg-3">
      <h6 class="u-sy--tight" style="padding: 10px 0">Vertragsinhaber</h6>
    </div>
    <div class="container u-sy--tight">
      ${purpose.apps!.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <div class="row">
        <a class="button button-tag button-tag--size-small" @click="${() => { this.revokeAllAppConsentsForPurpose(purpose); }}">
          Alle deaktivieren
        </a>
      </div>
    </div>
  `;
};
